<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('AddDailyCashierReport') | ToUppercase">
                <small>{{$t('Date') |ToUppercase}}</small><br>
                <datepicker v-model="reportDate"></datepicker>
                <vs-divider/>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                        <small>{{$t('User') |ToUppercase}}</small><br>
                        <vs-select v-model="selectedUser" class="selectExample w-full mb-63">
                            <vs-select-item v-for="(item,index) in users" :key="index" :text='item.firstname + " " + item.lastname' :value="item.id"/>
                        </vs-select>
                    </div>

                    <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                        <small>{{$t('Shift') |ToUppercase}}</small><br>
                        <vs-select v-model="selectedShift" class="selectExample w-full mb-3">
                            <vs-select-item v-for="(item,index) in shifts" :key="index" :text="item.name" :value="item.id"/>
                        </vs-select>
                    </div>
                    
                    <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
                        <small>{{$t('Cash') |ToUppercase}} (€)</small><br>
                        <vs-input class="w-full" type="number" name="name" v-model="cash" @input="updateTotalCash"/>
                    </div>
                    <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
                        <small>{{$t('Pos') |ToUppercase}} (€)</small><br>
                        <vs-input class="w-full" type="number" name="name" v-model="pos" @input="updateTotalPos"/>
                    </div>
                    <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
                        <small>{{$t('Total') |ToUppercase}} (€)</small><br>
                        <vs-input class="w-full" type="number" name="name" v-model="total"/>
                    </div>

                    <div class="vx-col sm:w-1/1 md:w-1/1 w-full">
                        <small>{{$t('Notes') |ToUppercase}}</small><br>
                        <vs-input class="w-full" type="text" name="notes" v-model="notes"/>
                    </div>

                    <div class="mt-6 ml-4">
                        <vs-button class="mr-2" @click="addDailyCashierReport">{{ $t("Add") | ToUppercase }}</vs-button>
                        <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                dailyCashierReportItems: [],
                dailyCashierReportItem: {},
                reportDate: new Date(),
                selectedUser: '',
                selectedShift: '',
                cash: 0,
                cashPrevious: 0,
                pos: 0,
                posPrevious: 0,
                total: 0,
                notes: '',
                users: [],
                shifts: [],
            };
        },
        methods: {
            updateTotalCash() {
                if((this.cash.match(/^\d+[\.\,]?\d{0,2}$/)) != null) {
                    this.cash = parseFloat((this.cash.match(/^\d+[\.\,]?\d{0,2}$/)).input);
                    this.cashPrevious = this.cash;
                }
                else {
                    if(this.cash.toString().length > 1) {
                        this.cash = this.cashPrevious;
                    }
                }

                this.total = Math.round((parseFloat(this.cash) + parseFloat(this.pos)) * 100) / 100;
            },
            updateTotalPos() {
                if((this.pos.match(/^\d+[\.\,]?\d{0,2}$/)) != null) {
                    this.pos = parseFloat((this.pos.match(/^\d+[\.\,]?\d{0,2}$/)).input);
                    this.posPrevious = this.pos;
                }
                else {
                    if(this.pos.toString().length > 1) {
                        this.pos = this.posPrevious;
                    }
                }

                this.total = Math.round((parseFloat(this.cash) + parseFloat(this.pos)) * 100) / 100;
            },
            updateUsers() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/users/')
                .then(function (response) {
                    thisIns.users = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju uporabnikov",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            updateShifts() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/shift/')
                .then(function (response) {
                    thisIns.shifts = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju izmen",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            addDailyCashierReport() {
                this.$vs.loading();

                //Prepare items array
                this.dailyCashierReportItem.userId = this.selectedUser;
                this.dailyCashierReportItem.shiftId = this.selectedShift;
                this.dailyCashierReportItem.cash = parseFloat(this.cash);
                this.dailyCashierReportItem.pos = parseFloat(this.pos);
                this.dailyCashierReportItem.total = parseFloat(this.total);
                this.dailyCashierReportItem.notes = this.notes;
                this.dailyCashierReportItems.push(this.dailyCashierReportItem);

                const thisIns = this;
                this.$http.post("/report/add?type=dailyCashier", {
                    date: thisIns.reportDate,
                    Items: thisIns.dailyCashierReportItems,
                }).then(function () {
                    thisIns.reportDate = null;
                    thisIns.selectedUser = 0;
                    thisIns.selectedShift = 0;
                    thisIns.cash = 0;
                    thisIns.pos = 0;
                    thisIns.total = 0;
                    thisIns.notes = '';
                    thisIns.$vs.notify({
                        text: "Dnevno poročilo blagajne shranjeno",
                        color: "success",
                    });
                    thisIns.$router.push('/report/dailyCashier');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
        },
        created() {
            this.updateShifts();
            this.updateUsers();
        }
    };
</script>